
import BaseStore from 'models/BaseStore'

export default class Store extends BaseStore {

  // アクセサ: 検索用キー値を取得
  static key(storeCode, floorCode) {
    if(storeCode instanceof Object) {
      floorCode = storeCode.floor_code
      storeCode = storeCode.store_code
    }
    return storeCode + '/' + floorCode
  }

  // アクセサ: 週間RE値を考慮したRE値を取得する
  dailyRE(date) {
    if (!(date instanceof Date)) date = new Date(date)
    const iweek = (date.getDay() + 6) % 7

    const res = {}
    for (let ire = 1; ire < 5; ++ire) {
      let re = this[`re${ire}_${iweek}`]
      if (re == null) re = this[`re${ire}`]
      res[`re${ire}`] = re
    }
    return res
  }
}
